export { CollapseInfo } from './CollapseInfo';
